<div class="flex items-center flex-none p-20 border-b sm:p-30 gap-x-20 border-gray-lighter">
  <h1 class="text-xl font-bold text-orange-400 mr auto">FIG Carrier Announcement</h1>
  <button mat-button mat-dialog-close="" class="ml-auto icon-button is-inverted is-primary" type="button" (click)="closeDialog()">
    <i class="material-icons">close</i>
  </button>
</div>
<div class="flex flex-col p-20 overflow-auto text-base sm:p-30 gap-y-20 ">
  <span>We want to keep you informed about potential service delays you may experience with the following carriers:
    <ul class="ml-20 font-semibold list-disc list-inside pt-15">
      <li>Transamerica</li>
      <li>Corebridge</li>
    </ul>
  </span>

  <span>We're working closely with these carriers, but current response times may be delayed. If you have other carrier options that fit your client's needs, consider using them for a smoother experience.</span>
  <span>We'll keep you updated on any changes.</span>
  <span>Thank you for your understanding and patience!</span>
</div>
<div class="flex items-center flex-none p-20 mt-auto border-t sm:p-30 border-gray-lighter">
  <button mat-button type="button" class="ml-auto button is-primary" (click)="launchTermLife()" aria-label="Launch Life Quote">
    <span class="flex items-center ml-5">Launch Life Quote<i class="material-icons mi-18">chevron_right</i></span>
  </button>
</div>